import { clientFactory } from '@hover/graphql';
import env from 'src/env';

const urlParams = new URLSearchParams(window.location.search);
const shareToken = urlParams.get('share_token');

const client = clientFactory({
  name: 'design-pro',
  version: process.env.APP_VERSION,
  // @ts-ignore
  'x-client-id': 'design-pro',
  'x-client-version': process.env.APP_VERSION,
  apiServer: env.API_SERVER,
  graphqlUri: env.GATEWAY_URL,
  // we pass cookieUpgrade to address this bug - https://hoverinc.atlassian.net/browse/CX-2864
  upgradeCookie: !shareToken,
});

export default client;
